import { css } from 'styled-components';

/** Small visual changes without changing layout or adding an accent border. */
export const softControlMotion = css`
  transition:
    scale var(--interaction-duration, 160ms) ease,
    background-color var(--interaction-duration, 160ms) ease,
    color var(--interaction-duration, 160ms) ease;
  @media (prefers-reduced-motion: no-preference) {
    &[aria-pressed='true']:not(:disabled):not([aria-disabled='true']),
    &[aria-selected='true']:not(:disabled):not([aria-disabled='true']) {
      scale: var(--control-selected-scale, 1.015);
    }
    @media (hover: hover) {
      &:hover:not(:disabled):not([aria-disabled='true']) {
        scale: var(--control-hover-scale, 1.025);
      }
    }
  }
  &:active:not(:disabled):not([aria-disabled='true']) {
    scale: 1;
  }
  @media (prefers-reduced-motion: reduce) {
    &,
    &:hover,
    &[aria-pressed='true'],
    &[aria-selected='true'] {
      scale: none;
      transition: none;
    }
  }
`;

/** Card hover treatments belong only to sidebar surfaces, including mobile rail drawers. */
export const softCardInteraction = css`
  :where(aside, [data-sidebar]) & {
    transition:
      scale var(--interaction-duration, 160ms) ease,
      background-color var(--interaction-duration, 160ms) ease;
    @media (hover: hover) {
      &:hover {
        scale: var(--card-hover-scale, 1.004);
        background-color: ${({ theme }) =>
          `color-mix(in srgb, ${theme.color.surface} 96%, ${theme.color.textPrimary})`};
      }
    }
    /* A transformed ancestor must not change the containing block of an open overlay. */
    &:has([role='dialog'], [role='menu']) {
      scale: none;
    }
    @media (prefers-reduced-motion: reduce) {
      &,
      &:hover {
        scale: none;
        transition: none;
      }
    }
  }
`;
